<ul class="nav__list primary-nav__items-list" *ngIf="hasItems()">
  <li *ngFor="let navItem of navItems" class="nav__item primary-nav__item" routerLinkActive="primary-nav__item--current" [class.primary-nav__item--current]="isRouteActive(navItem.route)">
    <app-nav-item *ngIf="navItem.isVisible" [navItem]="navItem"></app-nav-item>
  </li>
</ul>